<sm-overlay [backdropActive]="backdropActive$|async"></sm-overlay>
<sm-experiment-header
  [tableCols]="filteredTableCols$| async"
  [isArchived]="isArchived$ | async"
  [metricVariants]="metricVariants$ | async"
  [hyperParams]="hyperParams$ | async"
  [minimizedView]="minimizedView"
  [isMetricsLoading]="metricLoading$ | async"
  [tableFilters]="tableFilters$ | async"
  [showNavbarLinks]="(isPipeline$ | async) === false"
  [tableMode]="firstExperiment && (tableMode$ | async)"
  [rippleEffect]="tableModeAwareness$ | async"
  [addButtonTemplate]="addButton"
  (isArchivedChanged)="archivedChanged($event)"
  (selectedTableColsChanged)="selectedTableColsChanged($event)"
  (getMetricsToDisplay)="getMetricsToDisplay()"
  (selectedMetricToShow)="selectedMetricToShow($event)"
  (selectedHyperParamToShow)="selectedHyperParamToShow($event)"
  (removeColFromList)="removeColFromList($event)"
  (setAutoRefresh)="setAutoRefresh($event)"
  (clearSelection)="clearSelection()"
  (clearTableFilters)="clearTableFiltersHandler($event)"
  (tableModeChanged)="modeChanged($event); tableModeUserAware()"
></sm-experiment-header>
<ng-template #addButton let-isSmallScreen="smallScreen">
  <button
    class="btn btn-cml-primary d-flex justify-content-between align-items-center mr-3"
    [disabled]="isArchived$ | async"
    data-id="New Experiment"
    (click)="newExperiment()"
    [smTooltip]="isSmallScreen ? 'NEW EXPERIMENT' : ''"
  >
    <i class="al-icon al-ico-add sm"></i>
    <span *ngIf="!isSmallScreen" class="button-label">NEW EXPERIMENT</span>
  </button>
</ng-template>
<div class="experiment-body"
     [class.footer-visible]="((selectedExperiments$ | async) && (selectedExperiments$ | async)?.length > 1) || (showAllSelectedIsActive$ |async)">
  <as-split #split
            [useTransition]="true"
            [gutterDblClickDuration]="400"
            (gutterClick)="clickOnSplit()"
            (gutterDblClick)="closePanel()"
            (dragEnd)="splitSizeChange($event)"
            (dragStart)="disableInfoPanel()"
            (transitionEnd)="experimentsTable.table?.resize(100); experimentsTable.afterTableInit()"
  >
    <as-split-area
      [size]="100 - (splitInitialSize)"
      [order]="1"
    >
      <sm-experiments-table
        #experimentsTable
        class="align-self-stretch"
        selectionMode="single"
        [projects]="(projectsOptions$ | async)"
        [initialColumns]="tableCols"
        [colsOrder]="(tableColsOrder$ | async)"
        [tableCols]="tableCols$| async"
        [experiments]="experiments$ | async"
        [users]="users$ | async"
        [hyperParamsOptions]="hyperParamsOptions$ | async"
        [activeParentsFilter]="activeParentsFilter$ | async"
        [parents]="parent$ | async"
        [experimentTypes]="types$ | async"
        [tags]="tags$ | async"
        [systemTags]="systemTags$ | async"
        [tableSortFields]="(tableSortFields$ | async)"
        [tableSortOrder]="(tableSortOrder$ | async)"
        [tableFilters]="(tableFilters$ | async)"
        [selectedExperiments]="selectedExperiments$ | async"
        [selectedExperimentsDisableAvailable]="selectedExperimentsDisableAvailable$ | async"
        [selectedExperiment]="selectedTableExperiment$ |async"
        [minimizedView]="minimizedView"
        [noMoreExperiments]="noMoreExperiments$ | async"
        [split]="selectSplitSize$ | async"
        [contextMenuTemplate]="contextMenuExtendedTemplate"
        [contextMenuActive]="contextMenuActive"
        [entityType]="entityType"
        [hasExperimentUpdate]="selectedExperimentsHasUpdate$ | async"
        (experimentSelectionChanged)="experimentSelectionChanged($event)"
        (experimentsSelectionChanged)="experimentsSelectionChanged($event)"
        (sortedChanged)="sortedChanged($event)"
        (filterChanged)="filterChanged($event)"
        (tagsMenuOpened)="refreshTagsList()"
        (typesMenuOpened)="refreshTypesList()"
        (loadMoreExperiments)="getNextExperiments()"
        (columnsReordered)="columnsReordered($event)"
        (columnResized)="columnResized($event)"
        (openContextMenu)="onContextMenuOpen($event)"
        (clearAllFilters)="clearTableFiltersHandler($event)"
      >
      </sm-experiments-table>
    </as-split-area>
    <as-split-area
      [size]="splitInitialSize"
      [class.light-theme]="(isPipeline$ | async) === false"
      [class.info-disabled]="infoDisabled"
      [visible]="minimizedView" [order]="2"
    >
      <router-outlet></router-outlet>
    </as-split-area>
  </as-split>
</div>

<sm-entity-footer
  [footerState]="footerState$ | async"
  [footerItems]="footerItems"
  (footerItemClick)="onFooterHandler($event)"
  (tagSelected)="tagSelected($event, 'experiments')"
></sm-entity-footer>

<ng-template #contextMenuExtendedTemplate let-contextExperiment>
  <sm-experiment-menu-extended
    #contextMenuExtended
    [experiment]="contextExperiment"
    [selectedExperiment]="selectedExperiment$ | async"
    [selectedExperiments]="singleRowContext ? (selectedExperiment$ | async) ? [(selectedExperiment$ | async)] : undefined : selectedExperiments"
    [selectedDisableAvailableIsMultiple]="!singleRowContext"
    [selectedDisableAvailable]="singleRowContext ? getSingleSelectedDisableAvailable((selectedExperiment$ | async) || contextExperiment ) : (selectedExperimentsDisableAvailable$ | async)"
    [numSelected]="singleRowContext ? 1 : selectedExperiments.length"
    [tagsFilterByProject]="tagsFilterByProject$ | async"
    [projectTags]="projectTags$ | async"
    [companyTags]="companyTags$ | async"
    [activateFromMenuButton]="false"
    [useCurrentEntity]="singleRowContext"
    [minimizedView]="true"
    [tableMode]="!minimizedView"
    [backdrop]="menuBackdrop"
    (tagSelected)="onAddTag($event, contextExperiment)"
    (menuOpened)="setContextMenuStatus(true)"
    (menuClosed)="setContextMenuStatus(false)"
  ></sm-experiment-menu-extended>
</ng-template>
